import { render, staticRenderFns } from "./application21.vue?vue&type=template&id=39ae0e97&scoped=true&"
import script from "./application21.vue?vue&type=script&lang=ts&"
export * from "./application21.vue?vue&type=script&lang=ts&"
import style0 from "./application21.vue?vue&type=style&index=0&id=39ae0e97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae0e97",
  null
  
)

export default component.exports